import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const timeAttendanceListService = (
  params: Types.TimeAttendanceListRequest
) =>
  RestAPIClient.call<Types.TimeAttendanceListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const timeAttendanceImportService = (
  params: Types.TimeAttendanceImportRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Import,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const timeAttendanceImportEmployeeLeave = (params: {
  employeeIds: number[];
  year: number;
  month: number;
  templateId?: string;
  cycleId?: string;
  templatePeriod?: number;
}) =>
  RestAPIClient.call<
    RestAPIResponseList<{
      date: string;
      employeeId: number;
      employeeCode: string;
      duration: number;
    }>
  >({
    method: HTTPRequestMethods.GET,
    url: Paths.EmployeeLeaveShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const timeAttendanceImportHolidayShort = (params: {
  year: number;
  month: number;
}) =>
  RestAPIClient.call<
    RestAPIResponseList<{
      year: number;
      fromDate: string;
      toDate: string;
      totalDays: number;
    }>
  >({
    method: HTTPRequestMethods.GET,
    url: Paths.EmployeeLeaveShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const timeAttendanceImportOverTimeService = (
  params: Types.TimeAttendanceImportOverTimeRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.ImportOverTime,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const timeAttendanceImportLeaveService = (
  params: Types.TimeAttendanceImportLeaveRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.ImportLeaves,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const timeAttendanceSummaryList = (
  params: Types.TimeAttendanceSummaryRequest
) =>
  RestAPIClient.call<Types.TimeAttendanceSummaryResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.Summary,
    config: {
      requireAuthentication: true,
      params: {
        ...params,
      },
    },
  });

export const timeAttendanceSyncLeaveService = (data: {
  year: number;
  month: number;
  templateId?: string;
  templatePeriod?: number;
  cycleId?: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.SyncLeave,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const timeAttendanceSyncTimeAttendanceService = (data: {
  year: number;
  month: number;
  templateId?: string;
  templatePeriod?: number;
  cycleId?: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.SyncTimeAttendance,
    config: {
      requireAuthentication: true,
    },
    data,
  });
